// footer first menu title hide
$( document ).ready(function() {
  let current = document.querySelector('.footer__quicklinks');
  let prevSibling = current.previousElementSibling;
  prevSibling.style.display = "none";

});
/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

// ritu
// $(document).ready(function(){
// /* This code for variant functionality */
// setTimeout(function(){
//   // $("#shape .hulkapps_option_child").click(function(){
//   //   $('.hulkapps_swatch_option .hulkapps_option_child').not(this).css('background-position-y','top !important');
//   //   $(this).css('background-position-y','bottom!important');
//   // });
//   $(".diamond-showmore span").click(function(){
//     $('.theme__header').css('z-index','0');
//     $('.announcement__wrapper--top').css('z-index','0');
//     $('.hulkapps_product_options').css('visibility','visible').css('opacity','1').css('transform','translate3d(-100%,0,0)');
//     $('.close-variant').css('display','block');
//     $('.variant-cover').css('display','block');
//     $('.pt-popup').css('visibility','visible').css('opacity','1').css('transform','translate3d(-100%,0,0)');
//     $('body').css('overflow','hidden');
//     $('.js__header__stuck').css('z-index','0');
//   });
//   $(".close-variant, .variant-cover").click(function(){
//     $('.theme__header').css('z-index','5000');
//     $('.announcement__wrapper--top').css('z-index','5500');
//     $('.hulkapps_product_options').css('visibility','hidden').css('opacity','0').css('transform','translate3d(0%,0,0)');
//     $('.close-variant').css('display','none');
//     $('.variant-cover').css('display','none');
//     $('.pt-popup').css('visibility','hidden').css('opacity','0').css('transform','translate3d(0%,0,0)');
//     $('body').css('overflow','scroll');
//     $('.js__header__stuck').css('z-index','6000');
//   });
//   // console.log($('.spb-productoptionswatchwrapper').text());
//   // $('.spb-productoptionswatchwrapper').contents().filter(function() {
//   //   return this.nodeType === Node.TEXT_NODE;
//   // }).remove();
//   $('.hulkapps_product_options .hulkapps_option').each(function(i){
//     var Variant_name = "";
//     var default_Variant_option = "";
//     Variant_name = $(this).find('.hulkapps_option_name').text();
//     default_Variant_option = $(this).find('input').val();
//     console.log(Variant_name);
//     $('.selected_varian').append('<li class="Variant_details"><span class="Variant_name">'+Variant_name+'</span><span class="vd-dots">: </span><span class="Variant_option">'+default_Variant_option+'</span></li>');
//   });

//   _productVariantPrice();

//   // $('#infiniteoptions-container div').each(function(){
//   //   $(this).find('span label').each(function(i){
//   //     $(this).eq(i).addClass('var-border');
//   //   });
//   // });
//   $('.hulkapps_option_child').click(function(){
//     var group_name = $(this).closest('.hulkapps_option').find('.hulkapps_option_name').text();
//     var variant_val = $(this).find('input').attr('value');
//     $('.Variant_details').each(function(){
//       var change_value = $(this).find('.Variant_name').text();
//       if(change_value==group_name){
//         $(this).find('.Variant_option').text(variant_val);
//         console.log('1',group_name,'2',change_value);
//       }
//     });
//     $(this).parent().find('label').removeClass('var-border');
//       $(this).addClass('var-border');
//   });
//   var total_cost = $('.product__price__wrap .product__price span').text().replace(/[^0-9. ]/g, "");
//   $('.hulkapps_option_child').click(function(){
//     _productVariantPrice();
//   });

//   function _productVariantPrice(){
//     var variant_price = parseInt($('#calculated_option_total').text() );
//     var prod_price = parseInt($('.pt-popup_price').attr('pt-price'));
//     var _total = variant_price + prod_price;
//     $('.pt-popup_price').text('£'+_total+'.00');
//     $('[data-product-price]').text('£'+_total+'.00');
//   }
// }, 4000);
// });
var url = window.location.href.split('#');
if (url[1]=='metal-guide'){
var container = $('body');
    console.log(container);
             var scrollTo = $('.section-sidebar__body');
             var position = 
				container.offset().top
				+ container.scrollTop()-180;

  $('body,html').animate({
              scrollTop:position
});
}

/* end This code for variant functionality */

$(document).ready(function(){
   var week = new Array('Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday');
const d = new Date();
 d.setDate(d.getDate() + 7);
 var day =  week[d.getDay()];
 var date = d.getDate();
 var year = d.getFullYear();
  const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];
  var month = monthNames[d.getMonth()];
  $('.next__weak__timer').text('Price Increasing Soon. Held until '+day+' '+ date+' '+month +' '+year);
});

$(document).ready(function() {

  $(".btn_0").click(function(){   
   
   $( "#modal_0 .popRowSet" ).tabs({
  active: 0
  });

      $(".accordion_head").click(function () {
        if ($('.accordion_body').is(':visible')) {
            $(".accordion_body").slideUp(300);
            $(".plusminus").text('+');
        }
        if ($(this).next(".accordion_body").is(':visible')) {
            $(this).next(".accordion_body").slideUp(300);
            $(this).children(".plusminus").text('+');
        } else {
            $(this).next(".accordion_body").slideDown(300);
            $(this).children(".plusminus").text('-');
        }
    });
  });
  

   $(".btn_1").click(function(){
  
  $( "#modal_1 .popRowSet" ).tabs({
  active: 1
  });

      $(".accordion_head").click(function () {
        if ($('.accordion_body').is(':visible')) {
            $(".accordion_body").slideUp(300);
            $(".plusminus").text('+');
        }
        if ($(this).next(".accordion_body").is(':visible')) {
            $(this).next(".accordion_body").slideUp(300);
            $(this).children(".plusminus").text('+');
        } else {
            $(this).next(".accordion_body").slideDown(300);
            $(this).children(".plusminus").text('-');
        }
    });


  });


   $(".btn_2").click(function(){
  
  $( "#modal_2 .popRowSet" ).tabs({
  active: 2
  });

      $(".accordion_head").click(function () {
        if ($('.accordion_body').is(':visible')) {
            $(".accordion_body").slideUp(300);
            $(".plusminus").text('+');
        }
        if ($(this).next(".accordion_body").is(':visible')) {
            $(this).next(".accordion_body").slideUp(300);
            $(this).children(".plusminus").text('+');
        } else {
            $(this).next(".accordion_body").slideDown(300);
            $(this).children(".plusminus").text('-');
        }
    });


  });

  $(".btn_3").click(function(){

  $( "#modal_3 .popRowSet" ).tabs({
  active: 3
  });

      $(".accordion_head").click(function () {
        if ($('.accordion_body').is(':visible')) {
            $(".accordion_body").slideUp(300);
            $(".plusminus").text('+');
        }
        if ($(this).next(".accordion_body").is(':visible')) {
            $(this).next(".accordion_body").slideUp(300);
            $(this).children(".plusminus").text('+');
        } else {
            $(this).next(".accordion_body").slideDown(300);
            $(this).children(".plusminus").text('-');
        }
    });


  });


  $(".btn_4").click(function(){
  
  $( "#modal_4 .popRowSet" ).tabs({
  active: 4
  });

      $(".accordion_head").click(function () {
        if ($('.accordion_body').is(':visible')) {
            $(".accordion_body").slideUp(300);
            $(".plusminus").text('+');
        }
        if ($(this).next(".accordion_body").is(':visible')) {
            $(this).next(".accordion_body").slideUp(300);
            $(this).children(".plusminus").text('+');
        } else {
            $(this).next(".accordion_body").slideDown(300);
            $(this).children(".plusminus").text('-');
        }
    });


  });


       $(".btn_5").click(function(){
  
 $( "#modal_5 .popRowSet" ).tabs({
  active: 5
  });

      $(".accordion_head").click(function () {
        if ($('.accordion_body').is(':visible')) {
            $(".accordion_body").slideUp(300);
            $(".plusminus").text('+');
        }
        if ($(this).next(".accordion_body").is(':visible')) {
            $(this).next(".accordion_body").slideUp(300);
            $(this).children(".plusminus").text('+');
        } else {
            $(this).next(".accordion_body").slideDown(300);
            $(this).children(".plusminus").text('-');
        }
    });


  });



      $(".btn_6").click(function(){
  
  $( "#modal_6 .popRowSet" ).tabs({
  active: 6
  });

      $(".accordion_head").click(function () {
        if ($('.accordion_body').is(':visible')) {
            $(".accordion_body").slideUp(300);
            $(".plusminus").text('+');
        }
        if ($(this).next(".accordion_body").is(':visible')) {
            $(this).next(".accordion_body").slideUp(300);
            $(this).children(".plusminus").text('+');
        } else {
            $(this).next(".accordion_body").slideDown(300);
            $(this).children(".plusminus").text('-');
        }
    });


  });

  $(".btn_7").click(function(){
  
  $( "#modal_7 .popRowSet" ).tabs({
  active: 7
  });

      $(".accordion_head").click(function () {
        if ($('.accordion_body').is(':visible')) {
            $(".accordion_body").slideUp(300);
            $(".plusminus").text('+');
        }
        if ($(this).next(".accordion_body").is(':visible')) {
            $(this).next(".accordion_body").slideUp(300);
            $(this).children(".plusminus").text('+');
        } else {
            $(this).next(".accordion_body").slideDown(300);
            $(this).children(".plusminus").text('-');
        }
    });


  });

  $(".btn_8").click(function(){
  
  $( "#modal_8 .popRowSet" ).tabs({
  active: 8
  });

      $(".accordion_head").click(function () {
        if ($('.accordion_body').is(':visible')) {
            $(".accordion_body").slideUp(300);
            $(".plusminus").text('+');
        }
        if ($(this).next(".accordion_body").is(':visible')) {
            $(this).next(".accordion_body").slideUp(300);
            $(this).children(".plusminus").text('+');
        } else {
            $(this).next(".accordion_body").slideDown(300);
            $(this).children(".plusminus").text('-');
        }
    });


  });

  $(".btn_9").click(function(){
  
  $( "#modal_9 .popRowSet" ).tabs({
  active: 9
  });

      $(".accordion_head").click(function () {
        if ($('.accordion_body').is(':visible')) {
            $(".accordion_body").slideUp(300);
            $(".plusminus").text('+');
        }
        if ($(this).next(".accordion_body").is(':visible')) {
            $(this).next(".accordion_body").slideUp(300);
            $(this).children(".plusminus").text('+');
        } else {
            $(this).next(".accordion_body").slideDown(300);
            $(this).children(".plusminus").text('-');
        }
    });


  });

  $(".btn_10").click(function(){
  
  $( "#modal_10 .popRowSet" ).tabs({
  active: 10
  });

      $(".accordion_head").click(function () {
        if ($('.accordion_body').is(':visible')) {
            $(".accordion_body").slideUp(300);
            $(".plusminus").text('+');
        }
        if ($(this).next(".accordion_body").is(':visible')) {
            $(this).next(".accordion_body").slideUp(300);
            $(this).children(".plusminus").text('+');
        } else {
            $(this).next(".accordion_body").slideDown(300);
            $(this).children(".plusminus").text('-');
        }
    });


  });
  $(".btn_11").click(function(){
  
  $( "#modal_11 .popRowSet" ).tabs({
  active: 11
  });

      $(".accordion_head").click(function () {
        if ($('.accordion_body').is(':visible')) {
            $(".accordion_body").slideUp(300);
            $(".plusminus").text('+');
        }
        if ($(this).next(".accordion_body").is(':visible')) {
            $(this).next(".accordion_body").slideUp(300);
            $(this).children(".plusminus").text('+');
        } else {
            $(this).next(".accordion_body").slideDown(300);
            $(this).children(".plusminus").text('-');
        }
    });


  });
  
});









